import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getApiUrl } from "../utils/domainConfig";

/**
 * TrackingRedirect
 *
 * Public page that handles email tracking links (/grants/t/:token).
 * Shows a brief "Redirecting..." message, then navigates the browser
 * to the backend tracking endpoint which records the click event
 * and issues a 302 redirect to the final target URL.
 */
const TrackingRedirect: React.FC = () => {
  const { token } = useParams<{ token: string }>();
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!token) {
      setError(true);
      return;
    }

    const apiUrl = getApiUrl();
    const backendTrackingUrl = `${apiUrl}/grants/t/${token}`;

    // Redirect the browser to the backend endpoint.
    // The backend will record the tracking event and 302 redirect
    // to the final target URL.
    window.location.href = backendTrackingUrl;
  }, [token]);

  if (error) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <div className="text-center max-w-md">
          <div className="text-red-600 text-xl font-semibold mb-4">
            Nieprawidłowy link
          </div>
          <p className="text-neutral-600">
            Link, który kliknąłeś, jest nieprawidłowy lub wygasł.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
      <div className="text-center max-w-md">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
        <h2 className="text-2xl font-semibold text-neutral-900">
          Trwa przekierowanie...
        </h2>
        <p className="text-neutral-500 mt-2">Za chwilę zostaniesz przekierowany.</p>
      </div>
    </div>
  );
};

export default TrackingRedirect;
